import { FC } from "react";

import OutlinedButton from "../../../../../shared/components/buttons/OutlinedButton.styled";
import PrimaryButton from "../../../../../shared/components/buttons/PrimaryButton.styled";

interface CardButtonProps {
  children: React.ReactNode;
  highlight?: boolean;
  onClick?: () => void;
}

const CardButton: FC<CardButtonProps> = ({ children, highlight, onClick }) => {
  return highlight ? (
    <PrimaryButton onClick={onClick}>{children}</PrimaryButton>
  ) : (
    <OutlinedButton onClick={onClick}>{children}</OutlinedButton>
  );
};

export default CardButton;
